const rootClass = 'weet-components-button';
export { rootClass };
